import useForm from 'hooks/useForm';
import { validateEmailFields } from 'utils/emails';
export function useShareForm(_ref) {
  var defaultMessage = _ref.defaultMessage,
    defaultSubject = _ref.defaultSubject;
  return useForm({
    fields: {
      recipients: {
        getDefaultValue: function getDefaultValue() {
          return [];
        }
      },
      message: {
        getDefaultValue: function getDefaultValue() {
          return defaultMessage;
        },
        getError: function getError(value) {
          return validateEmailFields(value, 'alert_empty_message_error');
        }
      },
      subject: {
        getDefaultValue: function getDefaultValue() {
          return defaultSubject;
        },
        getError: function getError(value) {
          return validateEmailFields(value, 'alert_empty_subject_error');
        }
      },
      sendEmail: {
        getDefaultValue: function getDefaultValue() {
          return true;
        }
      },
      searchQuery: {
        getDefaultValue: function getDefaultValue() {
          return '';
        }
      }
    }
  });
}